import { render, staticRenderFns } from "./SundayService.vue?vue&type=template&id=0c815936&scoped=true&"
import script from "./SundayService.vue?vue&type=script&lang=js&"
export * from "./SundayService.vue?vue&type=script&lang=js&"
import style0 from "./SundayService.vue?vue&type=style&index=0&id=0c815936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c815936",
  null
  
)

export default component.exports